import React from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Breadcrumbs,
} from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';


const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  item: {
    width: '160px',
    marginTop: theme.spacing(2)
  },
  itemWrap: {
    cursor: 'pointer',
    height: '100%',
    padding: theme.spacing(1),
    textAlign: 'center',
    width: '100%',

    '&:hover': {
      outline: '1px solid #000000'
    },

    '&.selected': {
      outline: '2px solid ' + theme.palette.primary.main
    }
  },
  folderImg: {
    height: '60px',
    margin: '15px 0 15px 0',
    width: 'auto'
  },
  fileImg: {
    border: '2px solid #ffffff',
    boxShadow: '0 0 3px #969696',
    height: '90px',
    maxWidth: '100%',
    width: 'auto'
  },
  breadCrumbItem: {
    cursor: 'pointer'
  }
}));

/**
 * Shortens too long strings.
 *
 * @param {string} str - Original string to shorten
 * @param {number} length - Shorten string to this length.
 *
 * @return {string} - Shortened string or original string, if it is shorter than cutlength.
 */
function truncate(str = '', length = 18) {
  return str.length > length ? str.substring(0, length) + '...' : str;
}

const Folder = props => {
  const classes = useStyles();

  return (
    <li className={classes.item}>
      <div className={classes.itemWrap} role="button" onClick={() => props.handleFolderClick(props.folder.id, props.folder.name)}>
        <FolderIcon color="primary" className={classes.folderImg} />
        <div>{props.folder.name}</div>
      </div>
    </li>
  )
};

Folder.propTypes = {
  folder: PropTypes.object,
  handleFolderClick: PropTypes.func
}

const File = props => {
  const classes = useStyles();
  return (
    <li className={classes.item}>
      <div className={`${classes.itemWrap} ${props.selected ? 'selected' : ''}`} role="button" title={props.file.name} onClick={() => props.handleFileClick(props.file)} data-id={props.file.id}>
        <img className={classes.fileImg} src={props.file.thumbnail} alt="" loading="lazy" />
        <div>{truncate(props.file.name)}</div>
      </div>
    </li>
  );
};

File.propTypes = {
  file: PropTypes.object,
  selected: PropTypes.bool,
  handleFileClick: PropTypes.func
}

const Listing = (props) => {
  const classes = useStyles();

  return (
    <div>
      <Breadcrumbs>
        {(props.items?.breadCrumb || []).map((folder, index) =>
          <div key={folder.id} className={classes.breadCrumbItem} onClick={() => props.handleBreadCrumbClick(folder.id, index)}>{folder.name}</div>
        )}
      </Breadcrumbs>
      {props.loading ? <p>Loading...</p> :
        <ul className={classes.list}>
          {props.items.folders ? props.items.folders.map(folder => <Folder key={folder.id} folder={folder} handleFolderClick={props.handleFolderClick} />) : null}
          {props.items.files ? props.items.files.map(file => <File key={file.id} file={file} selected={props.selectedFiles.some(f => f.id === file.id)} handleFileClick={props.handleFileClick} />) : null}
        </ul>
      }
    </div>
  );
}

Listing.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.object,
  handleFolderClick: PropTypes.func,
  handleBreadCrumbClick: PropTypes.func,
  selectedFiles: PropTypes.array,
  handleFileClick: PropTypes.func
}

export default Listing;
